var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorageIcon = function SvgStorageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 15C4.16602 16.1508 6.77768 17.0833 9.99935 17.0833C13.221 17.0833 15.8327 16.1508 15.8327 15V4.99999C15.8327 3.84916 13.221 2.91666 9.99935 2.91666C6.77768 2.91666 4.16602 3.84916 4.16602 4.99999V15Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 5C15.8327 6.15083 13.221 7.08333 9.99935 7.08333C6.77768 7.08333 4.16602 6.15083 4.16602 5",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 11.6667C15.8327 12.8175 13.221 13.75 9.99935 13.75C6.77768 13.75 4.16602 12.8175 4.16602 11.6667",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8327 8.33331C15.8327 9.48415 13.221 10.4166 9.99935 10.4166C6.77768 10.4166 4.16602 9.48415 4.16602 8.33331",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgStorageIcon as ReactComponent };
export default __webpack_public_path__ + "storage-icon.svg";